import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Discord.svg'

export const IconDiscord = IconSVG as IconComponent
